import { createAction } from 'redux-api-middleware'
import type { RootState } from '../../reducers'
import { HUBBLE_API_TOKEN } from '../../store/middleware/APIUrl'
import type { Credit } from '../../types'
import ActionTypes from './actionTypes'

type FetchCreditsRequest = {
    type: typeof ActionTypes.CREDITS_FETCH_REQUEST;
    payload: never;
}

type FetchCreditsFailure = {
    type: typeof ActionTypes.CREDITS_FETCH_FAILURE;
    payload: Error;
}

type FetchCreditsSuccess = {
    type: typeof ActionTypes.CREDITS_FETCH_SUCCESS;
    payload: Credit[];
}

/**
 * Fetch credits in the DB
 */
function fetchCredits() {
    return createAction<RootState, Credit[], never>({
        endpoint: `${HUBBLE_API_TOKEN}/credits`,
        method: 'GET',
        types: [
            ActionTypes.CREDITS_FETCH_REQUEST,
            ActionTypes.CREDITS_FETCH_SUCCESS,
            ActionTypes.CREDITS_FETCH_FAILURE,
        ],
    })
}

export type FetchCreditsAction = FetchCreditsRequest
    | FetchCreditsFailure
    | FetchCreditsSuccess

export default fetchCredits
